import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CreditKeepIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M9.59009 14.12L8.34009 15.26C9.04009 16.03 9.97009 16.6 11.3701 16.72V18H12.9601V16.66C14.8101 16.35 15.6801 15.2 15.6801 13.83C15.6801 12.46 14.7501 11.62 12.8001 11.17V8.85999C13.4701 9.00999 13.9101 9.31999 14.2501 9.68999L15.5201 8.54999C14.9101 7.84999 14.0901 7.41999 12.9701 7.29999V5.98999H11.3801V7.29999C9.58009 7.50999 8.62009 8.47999 8.62009 9.93999C8.62009 11.29 9.47009 12.21 11.5601 12.64V15.15C10.7801 15.04 10.1301 14.66 9.60009 14.11L9.59009 14.12ZM12.7901 12.93C13.5801 13.17 13.7501 13.58 13.7501 13.99C13.7501 14.52 13.4401 14.95 12.7901 15.13V12.93ZM10.5301 9.89999C10.5301 9.35999 10.8401 8.97999 11.5501 8.83999V10.9C10.8401 10.7 10.5301 10.43 10.5301 9.89999Z"
        fill={color}
      />
      <path
        d="M12 0.25C11.59 0.25 11.25 0.59 11.25 1C11.25 1.41 11.59 1.75 12 1.75C17.65 1.75 22.25 6.35 22.25 12C22.25 17.65 17.65 22.25 12 22.25C11.59 22.25 11.25 22.59 11.25 23C11.25 23.41 11.59 23.75 12 23.75C18.48 23.75 23.75 18.48 23.75 12C23.75 5.52 18.48 0.25 12 0.25Z"
        fill={color}
      />
      <path
        d="M1.78988 12.9C1.73988 12.31 1.73988 11.7 1.78988 11.12C1.88988 10.15 0.359883 10.02 0.299883 10.99C0.239883 11.66 0.239883 12.36 0.299883 13.03C0.369883 14 1.88988 13.87 1.78988 12.9Z"
        fill={color}
      />
      <path
        d="M1.70011 8.04989C2.07011 8.21989 2.52011 8.06989 2.70011 7.68989C2.95011 7.14989 3.25011 6.62989 3.59011 6.14989C3.83011 5.80989 3.74011 5.33989 3.40011 5.10989C3.06011 4.86989 2.59011 4.95989 2.36011 5.29989C1.97011 5.85989 1.63011 6.44989 1.34011 7.06989C1.17011 7.44989 1.33011 7.88989 1.70011 8.06989V8.04989Z"
        fill={color}
      />
      <path
        d="M2.69998 16.3301C2.52998 15.9501 2.07998 15.7901 1.69998 15.9701C1.31998 16.1401 1.15998 16.5901 1.33998 16.9701C1.62998 17.5901 1.96998 18.1801 2.35998 18.7401C2.59998 19.0801 3.06998 19.1601 3.39998 18.9201C3.73998 18.6801 3.81998 18.2101 3.57998 17.8801C3.23998 17.3901 2.93998 16.8701 2.68998 16.3401L2.69998 16.3301Z"
        fill={color}
      />
      <path
        d="M6.08996 3.62005C6.56996 3.28005 7.08996 2.98005 7.62996 2.72005C8.00996 2.54005 8.16996 2.10005 7.98996 1.72005C7.80996 1.34005 7.36996 1.19005 6.98996 1.36005C6.36996 1.65005 5.77996 2.00005 5.22996 2.39005C4.88996 2.63005 4.80996 3.10005 5.04996 3.44005C5.28996 3.78005 5.75996 3.86005 6.08996 3.62005Z"
        fill={color}
      />
      <path
        d="M7.63997 21.28C7.09997 21.03 6.58997 20.73 6.09997 20.38C5.75997 20.14 5.28997 20.22 5.05997 20.56C4.81997 20.9 4.89997 21.37 5.23997 21.6C5.79997 21.99 6.38997 22.34 6.99997 22.63C7.36997 22.8 7.81997 22.65 7.99997 22.27C8.17997 21.9 8.01997 21.45 7.63997 21.27V21.28Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

CreditKeepIcon.displayName = 'CreditKeepIcon';
